import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-create-snapshot',
  templateUrl: './create-snapshot.component.html',
  styleUrls: ['./create-snapshot.component.scss'],
})
export class CreateSnapshotComponent implements OnInit {
  // Emits the snapshot payload back to the host once the user confirms. The
  // host keeps this modal open while the snapshot is being created (it can
  // take 30-60 seconds) and resets `submitting` on failure so the user can
  // retry without re-entering the form.
  @Output() snapshotConfirm = new EventEmitter<{
    VersionName: string;
    SchemaVersionId: number;
    AutoPromote: boolean;
  }>();

  snapshotForm!: FormGroup;
  schemaVersions: any[] = [];
  submitting = false;

  readonly maxVersionNameLength = 100;

  constructor(private fb: FormBuilder, private modal: CustomModalService) {}

  ngOnInit(): void {
    const initialState: any = this.modal?.modalService?.config?.initialState;
    this.schemaVersions = initialState?.['schemaVersions'] ?? [];

    this.snapshotForm = this.fb.group({
      versionName: ['', [Validators.required, Validators.maxLength(this.maxVersionNameLength)]],
      schemaVersion: [this.schemaVersions[0] ?? null],
      autoPromote: [true],
    });
  }

  get f() {
    return this.snapshotForm.controls;
  }

  onCreate() {
    const versionName = this.snapshotForm.value.versionName?.trim();
    if (this.snapshotForm.invalid || !versionName) {
      this.snapshotForm.markAllAsTouched();
      return;
    }
    this.submitting = true;
    const { schemaVersion, autoPromote } = this.snapshotForm.value;
    this.snapshotConfirm.emit({
      VersionName: versionName,
      SchemaVersionId: schemaVersion?.id ?? 1,
      AutoPromote: !!autoPromote,
    });
  }

  onClose() {
    if (this.submitting) {
      return;
    }
    this.modal.close();
  }
}
